<template>
  <div class="container_account_box">
    <!-- 账户信息卡片 -->
    <!-- 标签切换 -->
    <!-- <div class="title_top_box"> -->
    <div
      v-if="currentRoute === '/basicInfo/account/selfShipmentDetail'"
      class="back-button"
      @click="goBack"
    >
      <i class="el-icon-arrow-left" />
      <span>返回</span>
    </div>
    <div class="account_info_title">
      <div>
        <div class="title_h2">对公账号信息</div>
        <div class="account_info_tips">
          <i class="el-icon-warning-outline" />
          <span style="margin-left: 5px"
            >由贵公司开户行对合作公司账户进行充值,2~5分钟后进行手动刷新,即可显示充值金额</span
          >
        </div>
      </div>
      <div v-if="enterpriseName" style="font-size: 20px; font-weight: bold">
        {{ enterpriseName }}
      </div>
    </div>
    <!-- </div> -->

    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="当前合作平台" name="current">
        <el-tabs
          v-model="paymentChannelTab"
          type="border-card"
          @tab-click="handlePaymentChannelChange"
        >
          <el-tab-pane label="光大银行" name="ceb">
            <template v-if="currentCompany">
              <cardInfo
                type-pane="current"
                :party-code="partyCode"
                :current-company="currentCompany"
                :no-pay-amount="noPayAmount"
                :loading-amount="loaingAmount"
                @refreshNoPay="refreshNoPay"
                @refreshCompany="refreshCompany"
                @allocationAmount="showFundAllocation = true"
                @allocateSuccess="allocateSuccess"
              />
            </template>
            <div v-if="!currentCompany" class="no_company_box">
              当前暂无合作的公司
            </div>
          </el-tab-pane>
          <!-- TODO: -->
          <el-tab-pane v-if="alipayAccount" label="网商银行" name="alipay">
            <template v-if="currentCompany">
              <cardInfo
                type-pane="current"
                :is-alipay="true"
                :party-code="partyCode"
                :current-company="currentCompany"
                :no-pay-amount="noPayAmount"
                :loading-amount="loaingAmount"
                @refreshNoPay="refreshNoPay"
                @refreshCompany="refreshCompany"
                @allocationAmount="showFundAllocation = true"
                @allocateSuccess="allocateSuccess"
              />
            </template>
            <div v-if="!currentCompany" class="no_company_box">
              当前暂无合作的公司
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>

      <el-tab-pane v-if="isHasSub === 2" label="所有合作平台" name="all">
        <el-select
          v-if="companies.length"
          v-model="selectedCompany"
          placeholder="请选择平台"
          style="margin-bottom: 20px; margin-top: 10px"
          @change="changeCompany"
        >
          <el-option
            v-for="company in companies"
            :key="company.branchCode"
            :label="company.branchName"
            :value="company.branchCode"
          />
        </el-select>
        <template v-if="selectedObj">
          <!-- selectedObj  selectedObj.amount-->
          <!-- 企业对公账户 -->
          <cardInfo
            type-pane="all"
            :current-company="selectedObj"
            :no-pay-amount="noPayAmount"
            @refreshNoPay="refreshNoPay"
            @refreshCompany="refreshCompany"
            @allocationAmount="showFundAllocation = true"
            @allocateSuccess="allocateSuccess"
          />
        </template>
        <div v-if="!companies.length" class="no_company_box">
          当前暂无合作的公司
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 可分配金额 -->
    <!-- <el-card class="box-card" style="margin-bottom: 20px;">
      <div style="font-size: 20px; font-weight: bold">
        <span>可分配金额</span>
        <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
          <i class="el-icon-info" />
        </el-tooltip>

      </div>
    </el-card> -->
    <!-- 交易记录区域 -->
    <!-- 记录类型选项卡 -->
    <div v-if="showRecord" class="record-carousel-container">
      <!-- 顶部切换按钮 -->
      <div class="record-type-buttons">
        <el-button-group>
          <el-button
            :type="recordType === 'all' ? 'primary' : 'default'"
            @click="setRecordType('all')"
            >交易记录</el-button
          >
          <el-button
            :type="recordType === 'recharge' ? 'primary' : 'default'"
            @click="setRecordType('recharge')"
            >充值记录</el-button
          >
          <el-button
            v-if="isHasSub === 0 && paymentChannelTab !== 'alipay'"
            :type="recordType === 'withdraw' ? 'primary' : 'default'"
            @click="setRecordType('withdraw')"
            >资金分配记录</el-button
          >
        </el-button-group>
      </div>
      <!-- 轮播组件 -->
      <el-carousel
        ref="recordCarousel"
        :autoplay="false"
        indicator-position="none"
        arrow="never"
        :initial-index="carouselIndex"
      >
        <el-carousel-item class="item_height" name="all">
          <accountRecord
            v-if="recordType === 'all'"
            record-type="all"
            :payment-channel-tab="paymentChannelTab"
            :party-code="partyCode"
            :current-branch-code="currentBranchCode"
          />
        </el-carousel-item>
        <el-carousel-item class="item_height" name="recharge">
          <accountRecord
            v-if="recordType === 'recharge'"
            record-type="recharge"
            :payment-channel-tab="paymentChannelTab"
            :party-code="partyCode"
            :enterprise-name="enterpriseName"
          />
        </el-carousel-item>
        <el-carousel-item class="item_height" name="withdraw">
          <fundAllocationRecord
            v-if="recordType === 'withdraw'"
            :party-code="partyCode"
          />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 资金分配抽屉 -->
    <!-- <fund-allocation :visible.sync="showFundAllocation" /> -->
  </div>
</template>

<script>
import fundAllocationRecord from "./components/fundAllocationRecord.vue";
import {
  currentPaidingAmount,
  checkbalance,
  querySubaccountBalance
} from "@/api/shipment";
import { currentPartnerCompany } from "@/api/invoice";
import accountRecord from "@/views/basicInfo/shipment/shipmentAccount/components/accountRecord.vue";
import cardInfo from "./components/cardInfo.vue";
import fundAllocation from "./components/fundAllocation.vue";
import { mapState } from "vuex";
export default {
  name: "SelfShipmentDetail",
  components: {
    accountRecord,
    cardInfo,
    fundAllocation,
    fundAllocationRecord
  },
  data() {
    return {
      isAdmin: false,
      isHasSub: this.$store.state.user.party.companyType,
      loaingAmount: false,
      showRecord: true,
      // demo
      activeTab: "current",
      paymentChannelTab: "ceb",
      recordType: "all",
      currentPage: 1,
      pageSize: 10,
      showFullAccount: false,

      // 账户数据
      currentCompany: null,

      // 所有合作公司
      companies: [],
      selectedCompany: null, //所有公司选中公司的code
      partyCode: "",
      showAmount: false,
      showPending: false,
      noPayAmount: 0, //所有合作和平待支付的金额
      currentTab: "current",
      enterpriseName: "",
      showFundAllocation: false
    };
  },

  computed: {
    ...mapState({
      shipment: state => state.user.shipment
    }),
    alipayAccount() {
      return (
        (this.$route.query.aliAcc &&
          this.$route.query.branchCode === "lbb03") ||
        !!(
          this.shipment &&
          this.shipment.alipayAccount &&
          this.shipment.branchCode === "lbb03"
        )
      );
    },
    currentBranchCode() {
      let code =
        this.currentTab === "all" ? "" : this.currentCompany.branchCode;
      return code;
    },
    selectedObj() {
      return this.companies.find(
        item => item.branchCode === this.selectedCompany
      );
    },
    // 计算掩码后的账号
    maskedAccount() {
      const acc = this.currentCompany.account;
      return (
        acc.substring(0, 4) + " **** **** " + acc.substring(acc.length - 8)
      );
    },

    // 根据类型过滤记录
    filteredRecords() {
      let result = this.records;

      if (this.recordType === "recharge") {
        result = result.filter(item => item.amount > 0);
      } else if (this.recordType === "withdraw") {
        result = result.filter(item => item.amount < 0);
      }

      // 分页处理
      const start = (this.currentPage - 1) * this.pageSize;
      return result.slice(start, start + this.pageSize);
    },

    // 根据recordType计算轮播索引
    carouselIndex() {
      const typeMap = {
        all: 0,
        recharge: 1,
        withdraw: 2
      };
      return typeMap[this.recordType] || 0;
    },
    currentRoute() {
      return this.$route.path;
    }
  },

  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;

    let query = this.$route.query;
    console.log(">>>>>>>>>>>", this.$route);
    if (this.currentRoute === "/financial/selfShipmentDetail") {
      this.partyCode = query.code;
    } else {
      this.partyCode = this.$store.state.user.code;
    }
    this.enterpriseName = query.enterpriseName || "";
    this.getCurrentPartnerCompany();
    console.log("query======", query);
  },

  methods: {
    allocateSuccess() {
      console.log("allocateSuccess======!!!!!!", this.currentCompany);
      this.getCurrentPartnerCompany();
    },
    refreshNoPay() {
      console.log("refreshNoPay======!!!!!!", this.currentTab);
      // if (this.currentTab === "all") {
      //   this.getCurrentPaidingAmount(this.selectedCompany, "refresh");
      // } else {
      this.getCurrentPaidingAmount(this.currentCompany.branchCode, "refresh");
      // }
    },
    changeCompany(value) {
      console.log("changeCompany======", value);
      this.getCurrentPaidingAmount(this.selectedCompany);
    },

    goBack() {
      this.$router.go(-1);
    },
    refreshCompany() {
      //刷新支付宝余额
      if (this.paymentChannelTab === "alipay") {
        this.querySubaccountBalance();
        return;
      }
      if (this.isHasSub === 1) {
        this.getCurrentPartnerCompany("refresh");
        return;
      }
      this.refreshBalance();
    },
    async getCurrentPartnerCompany(type = "") {
      this.loaingAmount = true;
      try {
        let data = {
          partyCode: this.partyCode
        };
        let res = await currentPartnerCompany(data);
        if (res.status === 0) {
          if (type === "refresh") {
            this.$message.success("刷新成功");
          }
          // 所有合作公司
          this.companies = res.data.list;
          // this.companies = this.companies.filter(
          //   item => item.mainAccountFlag === 1
          // );
          if (this.companies.length) {
            this.selectedCompany = this.companies[0].branchCode;
          }
          console.log("this.companies======", this.companies);
          //当前合作公司
          if (res.data && Object.keys(res.data.partnerCompany).length) {
            this.currentCompany = res.data.partnerCompany || null;
            this.getCurrentPaidingAmount(this.currentCompany.branchCode);
          }
          console.log("this.currentCompany======", this.currentCompany);
        }
        console.log("res=======", res);
      } catch (err) {
        // this.$message.error("网络异常，请重试");
      } finally {
        this.loaingAmount = false;
      }
    },
    async getCurrentPaidingAmount(branchCode, type = "") {
      if (!branchCode) return;
      let data = {
        branchCode,
        partyCode: this.partyCode
      };
      let res = await currentPaidingAmount(data);
      if (res.status === 0) {
        this.noPayAmount = res.data.amount;
        if (type === "refresh") {
          this.$message.success("刷新成功");
        }
      }
      console.log("currentPaidingAmount========", res);
    },
    // 标签切换处理
    handleTabChange(tab) {
      console.log("切换到标签:", tab.name);
      this.currentTab = tab.name;
      if (tab.name === "all") {
        this.getCurrentPaidingAmount(this.selectedCompany);
      } else {
        this.getCurrentPaidingAmount(this.currentCompany.branchCode);
      }
      this.showRecord = false;
      this.$nextTick(() => {
        this.showRecord = true;
      });
    },

    // 支付渠道切换（光大银行 / 支付宝）
    handlePaymentChannelChange(tab) {
      if (tab.name === "alipay") {
        if (this.recordType === "withdraw") {
          this.setRecordType("all");
        }
        this.querySubaccountBalance(false);
      } else if (tab.name === "ceb") {
        this.getCurrentPartnerCompany();
      }
    },

    // 设置记录类型并切换轮播
    setRecordType(type) {
      this.recordType = type;
      // 使用$nextTick确保DOM更新后再操作轮播组件
      this.$nextTick(() => {
        if (this.$refs.recordCarousel) {
          this.$refs.recordCarousel.setActiveItem(this.carouselIndex);
        }
      });
    },

    querySubaccountBalance(showToast = true) {
      this.loaingAmount = true;
      querySubaccountBalance({ partyCode: this.partyCode })
        .then(response => {
          this.loaingAmount = false;
          if (showToast) {
            this.$message({
              message: "账户余额：" + response.data.alipayAmount,
              type: "success"
            });
          }
          this.currentCompany.amount = response.data.alipayAmount;
        })
        .catch(call => {
          this.loaingAmount = false;
          this.$message.error("网络异常，请重试");
        });
    },

    // 刷新余额
    refreshBalance() {
      this.loaingAmount = true;
      checkbalance({ partCode: this.partyCode })
        .then(response => {
          this.loaingAmount = false;
          this.$message({
            message: "账户余额：" + response.data.amount,
            type: "success"
          });
          this.currentCompany.amount = response.data.amount;
        })
        .catch(call => {
          this.loaingAmount = false;
          this.$message.error("网络异常，请重试");
        });
    },

    // 充值操作
    recharge() {
      this.$message.info("打开充值界面");
      // 实际充值逻辑
    },

    // 提现操作
    withdraw() {
      this.$message.warning("提现功能开发中");
    },

    // 查看回单
    viewReceipt(record) {
      this.$alert(`显示 ${record.waybill} 的回单详情`, "电子回单", {
        confirmButtonText: "确定",
        callback: action => {}
      });
    },

    // 分页处理
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    },

    handleCurrentChange(page) {
      this.currentPage = page;
    }
  }
};
</script>

<style scoped lang="scss">
.tips_box {
  font-size: 13px;
  background: #f3f3f3;
  border-radius: 10px;
  padding: 10px;
  .m_r_20 {
    margin-left: 20px;
  }
}
.item_height {
  height: 720px;
}
.account_info_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 5px;
  flex-wrap: wrap;

  .title_h2 {
    font-size: 20px;
    font-weight: bold;
    margin-right: 20px;
  }
}
.title_top_box {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  // border:1px solid;
}
.back-button {
  width: 79px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #409eff;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
  margin-left: -20px;
  margin-top: -3px;
  &:hover {
    background-color: #ecf5ff;
  }

  i {
    margin-right: 5px;
    font-size: 14px;
  }
}
.account_info_tips {
  color: #a3a3a3;
  flex: 1;
  display: flex;
  align-items: center;
}

.account_info_row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  // border-bottom: 1px dashed #ebeef5;
}

.m_b_0 {
  margin-bottom: 0px !important;
}

.account_info_label {
  width: 130px;
  color: #606266;
  font-weight: 600;
  margin-right: 15px;
  text-align: right;
  font-size: 15px;
}

.account_info_value {
  color: #303133;
  font-size: 15px;
}

.container_account_box {
  padding: 30px;
}
.container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 15px;
}

.account-card,
.record-card {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.company-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #2a6efd;
}

.balance-row {
  margin-top: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.balance-row > span {
  margin-right: 10px;
}

.highlight {
  font-size: 18px;
  color: #f56c6c;
  margin-right: 8px;
}

.bank-account {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.bank-account i {
  margin-left: 8px;
  color: #2a6efd;
}

.refresh_btn_box {
  display: flex;
  align-items: center;
}

.refresh_btn_text {
  margin-right: 3px;
  color: #2a6efd;
  cursor: pointer;
  &:hover {
    cursor: pointer;
  }
}
.refresh_icon {
  color: #2a6efd;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
}

.help-tips {
  margin-top: 30px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}

.help-tips p {
  margin: 5px 0;
}

/* 轮播相关样式 */
.record-carousel-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 180px;
}

.record-type-buttons {
  padding: 15px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  // justify-content: center;
}

.el-carousel {
  height: 720px;
  // border: 2px solid red;
}

.el-carousel__item {
  padding: 20px;
  // overflow-y: auto;
}

/* 确保轮播项内容不会溢出 */
.el-carousel__container {
  height: 100%;
}
.no_company_box {
  margin-top: 30px;
  margin-bottom: 190px;
}
.psw_icon {
  width: 20px;
  height: 20px;
  margin-right: 30px;
  cursor: pointer;
}
.copy_text {
  color: #409eff;
  cursor: pointer;
  margin-left: 10px;
  &:hover {
    opacity: 0.6;
  }
}
.all_copy {
  margin-left: 138px;
  margin-bottom: 15px;
}
</style>
